module.exports = __webpack_public_path__ + "img/icon65.1d91fa64.png";